<template>
  <div>
    <v-row>
      <v-col cols="12">
        <div class="form-base__title">
          {{ label }}
        </div>
      </v-col>

      <v-col cols="4">
        <v-text-field
          v-model.trim="v.lastName.$model"
          :errorMessages="getValidationErrorText(v.lastName)"
          label="Фамилия"
          outlined
        />
      </v-col>
      <v-col cols="4">
        <v-text-field
          v-model.trim="v.firstName.$model"
          :errorMessages="getValidationErrorText(v.firstName)"
          label="Имя"
          outlined
        />
      </v-col>
      <v-col cols="4">
        <v-text-field
          v-model.trim="v.patronymic.$model"
          :errorMessages="getValidationErrorText(v.patronymic)"
          label="Отчество (при наличии)"
          outlined
        />
      </v-col>

      <v-col cols="4">
        <v-text-field
          v-model="v.snils.$model"
          :errorMessages="getValidationErrorText(v.snils)"
          label="СНИЛС"
          v-mask="['###-###-### ##']"
          outlined
          :disabled="true"
        />
      </v-col>
      <v-col cols="4">
        <v-text-field
          v-model="v.inn.$model"
          :errorMessages="getValidationErrorText(v.inn)"
          label="ИНН"
          v-mask="['############']"
          outlined
          :disabled="true"
        />
      </v-col>

      <v-col cols="6">
        <v-text-field
          v-model="v.status.$model"
          :errorMessages="getValidationErrorText(v.status)"
          label="Должность или статус представителя (при наличии)"
          outlined
        />
      </v-col>
    </v-row>

    <StatusDocument :v="v.documents.statusDocument" />

    <AuthorityDocument :v="v.documents.authorityDocument" />

    <v-row>
      <v-col cols="3">
        <v-text-field
          v-model="v.email.$model"
          :errorMessages="getValidationErrorText(v.email)"
          label="Адрес электронной почты"
          outlined
        />
      </v-col>
      <v-col cols="3">
        <v-text-field
          v-model="v.phone.$model"
          :errorMessages="getValidationErrorText(v.phone)"
          v-mask="['+7 ### ###-##-##']"
          label="Контактный телефон"
          outlined
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { maxLength, minLength, required } from 'vuelidate/lib/validators';
import { mdiAlertCircleOutline } from '@mdi/js';

import {
  EMAIL,
  EMOJI,
  getValidationErrorText,
  INN_ROD,
  MAX_LENGTH,
  MAX_LENGTH_EMAIL,
  MinLength,
  PERSON_NAME,
  SNILS_ROD,
} from '@/utils/validate';
import { DocumentType } from '@/types/services';
import StatusDocument, {
  getStatusDocumentValidation,
  statusDocumentModel,
} from '@/components/services/elements/StatusDocument';
import AuthorityDocument, {
  authorityDocumentValidation,
  authorityDocumentModel,
} from '@/components/services/elements/AuthorityDocument';

export const assigneeValidate = (assignee) => ({
  lastName: {
    required,
    maxLength: maxLength(MAX_LENGTH),
    PERSON_NAME,
  },
  firstName: {
    required,
    maxLength: maxLength(MAX_LENGTH),
    PERSON_NAME,
  },
  patronymic: {
    maxLength: maxLength(MAX_LENGTH),
    PERSON_NAME,
  },
  snils: {
    required,
    minLength: minLength(MinLength.SNILS),
    SNILS: SNILS_ROD,
  },
  inn: {
    minLength: minLength(12),
    required,
    INN: INN_ROD,
  },
  status: {
    maxLength: maxLength(1000),
    EMOJI,
  },
  email: {
    required,
    EMAIL,
    maxLength: maxLength(MAX_LENGTH_EMAIL),
  },
  phone: {
    required,
    minLength: minLength(16),
  },
  documents: {
    statusDocument: getStatusDocumentValidation(assignee, true),
    authorityDocument: authorityDocumentValidation,
  },
});

export const assigneeModel = {
  lastName: '',
  firstName: '',
  patronymic: '',
  snils: '',
  inn: '',
  status: '',
  email: '',
  phone: '',
  documents: {
    statusDocument: statusDocumentModel,
    authorityDocument: authorityDocumentModel,
  },
};

export default {
  name: 'ExtractionRodAssignee',
  components: {
    StatusDocument,
    AuthorityDocument,
  },
  props: {
    v: {
      type: Object,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    mdiAlertCircleOutline,
    getValidationErrorText,
    DocumentType,
  }),
};
</script>
